import { styled } from '@lichtblick/styled';
import { Spacing } from '@lichtblick/theme';

export const Container = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: ${Spacing.M};
`;
